import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {JBMTableColumnAlignment, JBMTableColumnType, JBMTableDisplayValue, StringIDdisplay} from "./JBMTable.component";
import {DatePipe} from "@angular/common";
import {MoneyPipe} from "../../../pipes/money.pipe";

@Component({
  selector: 'td[jbm-table-cell]',
  templateUrl: './JBMTableCell.component.html',
  providers: [MoneyPipe, DatePipe]
})
export class JBMTableCellComponent implements OnInit {
  @Input() type: JBMTableColumnType=JBMTableColumnType.string;
  @Input() align: JBMTableColumnAlignment=JBMTableColumnAlignment.left;
  @Input() data: any;
  @Input() idValue: any;
  @Input() stringIDdisplay: StringIDdisplay=StringIDdisplay.none;
  @Input() displayValues: JBMTableDisplayValue[] = [];

  readonly dateType = JBMTableColumnType.date;
  readonly datetimeType = JBMTableColumnType.datetime;
  readonly datetimesecondsType = JBMTableColumnType.datetimeseconds;
  readonly dateshortType = JBMTableColumnType.dateshort;
  readonly timeType = JBMTableColumnType.time;
  readonly timesecondsType = JBMTableColumnType.timeseconds;
  readonly priceType = JBMTableColumnType.price;
  readonly stringAndIDType = JBMTableColumnType.stringAndID;
  readonly stringIDdisplayType = StringIDdisplay

  displayContent: string = '';
  private displayClassName: string = '';

  ngOnInit() {
    if (this.type === undefined) this.type = JBMTableColumnType.string;
    if (this.data === undefined) this.data = '';
    if (this.displayValues === undefined) this.displayValues = [];
    this.resolveDisplayValues();
  }

  @HostBinding('class')
  get hostClass(): string {
    const checked = typeof this.data === 'boolean' && this.data && !this.displayClassName ? 'checked' : '';
    return [this.displayClassName, checked].filter(Boolean).join(' ');
  }

  @HostBinding('style.textAlign')
  get textAlign(): string {
    let alignment = this.align;
    if (alignment === undefined) {
      switch (this.type) {
        case JBMTableColumnType.number:
        case JBMTableColumnType.price:
          alignment = JBMTableColumnAlignment.right;
          break;
        case JBMTableColumnType.boolean:
          alignment = JBMTableColumnAlignment.center;
          break;
        default:
          alignment = JBMTableColumnAlignment.left;
      }
    }
    const alignments = ['left', 'center', 'right'];
    return alignment === JBMTableColumnAlignment.left ? '' : alignments[alignment];
  }

  private resolveDisplayValues() {
    for (const d of this.displayValues) {
      if (this.data === d.dataValue && d.displayValue !== undefined) {
        this.displayContent = d.displayValue;
        this.displayClassName = d.className ?? '';
        return;
      }
    }
    this.displayContent = '';
    this.displayClassName = '';
  }
}
